import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { swRegistrationPromise } from './serviceWorkerRegistration';

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

const isConfigured = () =>
  !!(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.messagingSenderId);

let _messaging = null;

const getFirebaseMessaging = () => {
  if (!isConfigured()) {
    console.warn('[FCM] Firebase not configured — check REACT_APP_FIREBASE_* in frontend/.env');
    return null;
  }
  if (_messaging) return _messaging;
  try {
    const app  = getApps().length ? getApp() : initializeApp(firebaseConfig);
    _messaging = getMessaging(app);
    return _messaging;
  } catch (err) {
    console.error('[FCM] Firebase init failed:', err.message);
    return null;
  }
};

export const requestPermission = async () => {
  if (!('Notification' in window)) {
    console.warn('[FCM] This browser does not support notifications');
    return false;
  }
  const result = await Notification.requestPermission();
  if (result !== 'granted') {
    console.warn('[FCM] Notification permission:', result);
  }
  return result === 'granted';
};

export const getFCMToken = async () => {
  const messaging = getFirebaseMessaging();
  if (!messaging) return null;

  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  if (!vapidKey) {
    console.warn('[FCM] REACT_APP_FIREBASE_VAPID_KEY is not set');
    return null;
  }

  try {
    /* Use the already-registered service-worker.js so Firebase does NOT
       try to register a second SW at / (which caused the conflict). */
    const swReg = await swRegistrationPromise;
    const opts  = { vapidKey, ...(swReg ? { serviceWorkerRegistration: swReg } : {}) };
    const token = await getToken(messaging, opts);
    if (!token) {
      console.warn('[FCM] getToken returned empty — check browser notification permission and VAPID key');
    } else {
      console.log('[FCM] Token obtained successfully');
    }
    return token || null;
  } catch (err) {
    console.error('[FCM] getToken failed:', err.message, err.code ? `(${err.code})` : '');
    return null;
  }
};

export const onForegroundMessage = (handler) => {
  const messaging = getFirebaseMessaging();
  if (!messaging) return () => {};
  return onMessage(messaging, handler);
};
